module.exports = __webpack_public_path__ + "c487e52e85f5d77b57717c2fd2fb2d0b.png";